module.exports = __webpack_public_path__ + "img/vote_money_r.36aa048a.png";